import React, { useEffect, useState } from "react";
import { romeToday } from "./eventUtils";

/* Instant (ms) of a Europe/Rome wall-clock date+time, independent of the visitor's timezone. */
export function romeInstant(dateIso, time = "00:00") {
    const [y, m, d] = dateIso.split("-").map(Number);
    const [hh, mm] = time.split(":").map(Number);
    const wall = Date.UTC(y, m - 1, d, hh || 0, mm || 0);
    const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "Europe/Rome", hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" })
        .formatToParts(new Date(wall)).map((x) => [x.type, x.value]));
    const asRome = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return wall - (asRome - wall);
}

export function countdownParts(ev, now = Date.now()) {
    const today = romeToday(new Date(now));
    if (ev.end_date < today) return { phase: "past" };
    if (ev.start_date <= today) return { phase: "live" };
    const diff = Math.max(0, romeInstant(ev.start_date, ev.start_time || "00:00") - now);
    const mins = Math.floor(diff / 60000);
    return { phase: "upcoming", days: Math.floor(mins / 1440), hours: Math.floor((mins % 1440) / 60), minutes: mins % 60 };
}

/* Live countdown: days · hours · minutes to the event start (Europe/Rome). Never negative; "live" during the event days. */
export default function EventCountdown({ ev, lang, compact = false, testid = "event-countdown" }) {
    const en = lang === "en";
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);
    const c = countdownParts(ev, now);
    if (c.phase === "past") return null;
    if (c.phase === "live") {
        return <span data-testid={testid} className="label-mono text-abnormal-acid">{en ? "HAPPENING NOW" : "IN CORSO"}</span>;
    }
    const pad = (n) => String(n).padStart(2, "0");
    if (compact) {
        return (
            <span data-testid={testid} className="label-mono text-abnormal-acid whitespace-nowrap">
                -{c.days} {en ? "DAYS" : "GIORNI"} · {pad(c.hours)}h {pad(c.minutes)}m
            </span>
        );
    }
    const cells = [[c.days, en ? "DAYS" : "GIORNI"], [c.hours, en ? "HOURS" : "ORE"], [c.minutes, en ? "MIN" : "MIN"]];
    return (
        <div data-testid={testid} className="inline-flex items-stretch border border-white/15 bg-abnormal-charcoal divide-x divide-white/10">
            {cells.map(([v, l]) => (
                <div key={l} className="px-4 py-2 text-center min-w-[72px]">
                    <p className="font-display text-3xl md:text-4xl leading-none text-abnormal-paper tabular-nums">{pad(v)}</p>
                    <p className="label-mono text-abnormal-paperDim/70 mt-1 !text-[9px]">{l}</p>
                </div>
            ))}
        </div>
    );
}
